import { useQuery } from '@tanstack/react-query';

import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useSessionNote(sessionId: string | undefined) {
  return useQuery({
    queryKey: sessionsKeys.operation('note', sessionId ?? ''),
    queryFn: () => {
      if (!sessionId) throw new Error('missing id');
      return sessionsService.getNote(sessionId);
    },
    enabled: Boolean(sessionId),
  });
}
